/*
 *  Project: dux - resource scroll
 *  Description: shadow on resource-header and toolbar-fixed-top
 *  Author: bwin
 */

require( 'tab' );
require( 'vendor/jquery-watch' );

;(function ( $, window, document, undefined ){

    var pluginName = 'res_scroll',
        _self,
        _win = $( window ),
        defaults = {
            origin: 'resource',
            header: 'resource-header',
            content: 'resource-content',
            toolbar: 'toolbar-fixed-top'
        };

    function Plugin( element, options ){

        _self = this;

        this.element = element;
        this.$element = $( element );

        this.options = $.extend( {}, defaults, options );

        this._defaults = defaults;
        this._name = pluginName;

        this.init();

    }

    $.extend( Plugin.prototype, {
        init: function (){

            var $resCnt = this.$element.children( '.' + _self._defaults.content ),
                $cntTab = $( 'a[data-toggle="tab"]' );

            $cntTab.on( 'shown.bs.tab', function (){

                $resCnt.scrollTop( 0 );

                _self._relieveElms();

            } );

            _win.on( 'resize', function (){
                _self._setMargins();
            } );

            $resCnt.on( 'scroll', function (){
                _self._fixElms();
            } );

            this._watchVisibility( '_attrVisibility' );

        },
        _watchVisibility: function ( id ){

            var $cntTb = this.$element.children( '.' + _self._defaults.content ).find( '.' + _self._defaults.toolbar );

            $cntTb.unwatch( id );

            var originVisibility = $cntTb.is( ':visible' );

            $cntTb.watch( {
                properties: 'attr_style,attr_class',
                id: id,
                watchChildren: false,
                callback: function ( data, i ){

                    var $this = $( this ),
                        propChanged = data.props[ i ],
                        valChanged = $.trim( data.vals[ i ] );

                    // watch for class and style attributes changing the visibility of the toolbar
                    // re-fix elements on visibility changes and keep current visibility state
                    // in memory

                    if (
                        propChanged === 'attr_style' && valChanged.match( 'display' ) && $this.is( ':visible' ) !== originVisibility ||
                        propChanged === 'attr_class' && $this.is( ':visible' ) !== originVisibility ) {

                        _self._fixElms();
                        originVisibility = $this.is( ':visible' );
                    }
                }
            } )
        },
        _getScrlVal: function (){

            var $resCnt = this.$element.children( '.' + _self._defaults.content ),
                $cntTb = $resCnt.find( '.' + _self._defaults.toolbar );

            if ( $cntTb.is( ':visible' ) && !$cntTb.hasClass( 'fixed' ) ) {
                return $cntTb.outerHeight();
            }

            return 0;
        },
        _fixElms: function (){

            var $resHd = this.$element.children( '.' + _self._defaults.header ),
                $resCnt = this.$element.children( '.' + _self._defaults.content ),
                cntScroll = $resCnt.scrollTop(),
                $cntTb = $resCnt.find( '.' + _self._defaults.toolbar );

            if ( cntScroll > _self._getScrlVal() ) {

                if ( !$cntTb.length || $cntTb.is( ':hidden' ) ) {

                    $resHd.addClass( 'has-shadow' );

                } else {

                    $cntTb
                        .addClass( 'fixed' )
                        .css( { top: $resHd.outerHeight() } )
                        .addClass( 'has-shadow fade-in-down' );

                    $resHd.removeClass( 'has-shadow' );
                }

            } else {

                _self._relieveElms();
            }

        },
        _setMargins: function (){

            var $resHd = this.$element.children( '.' + _self._defaults.header ),
                $resCnt = this.$element.children( '.' + _self._defaults.content ),
                $cntTb = $resCnt.find( '.' + _self._defaults.toolbar );

            if ( $cntTb.hasClass( 'fixed' ) ) {
                $cntTb.css( { top: $resHd.outerHeight() } )
            }

        },
        _relieveElms: function (){

            var $resHd = this.$element.children( '.' + _self._defaults.header ),
                $resCnt = this.$element.children( '.' + _self._defaults.content ),
                cntScroll = $resCnt.scrollTop(),
                $cntTb = $resCnt.find( '.' + _self._defaults.toolbar );

            $cntTb
                .css( 'top', '' )
                .removeClass( 'fixed has-shadow fade-in-down' );

            if ( cntScroll > _self._getScrlVal() ) {

                if ( !$cntTb.length || $cntTb.is( ':hidden' ) ) {

                    $resHd.addClass( 'has-shadow' );

                }
            } else {

                $resHd.removeClass( 'has-shadow' );
            }

        }
    } );

    $.fn[ pluginName ] = function ( options ){
        var args = arguments;

        if ( options === undefined || typeof options === 'object' ) {

            return this.each( function (){

                if ( !$.data( this, 'plugin_' + pluginName ) ) {
                    $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
                }

            } );

        } else if ( typeof options === 'string' && options[ 0 ] !== '_' && options !== 'init' ) {

            var returns;

            this.each( function (){

                var instance = $.data( this, 'plugin_' + pluginName );

                if ( instance instanceof Plugin && typeof instance[ options ] === 'function' ) {
                    returns = instance[ options ].apply( instance, Array.prototype.slice.call( args, 1 ) );
                }

                if ( options === 'destroy' ) {
                    $.data( this, 'plugin_' + pluginName, null );
                }

            } );

            return returns !== undefined ? returns : this;
        }
    };

})( jQuery, window, document );

;(function ( $, window, document, undefined ){
    $( function (){
        $( '.resource' ).each( function (){

            var $this = $( this );

            $this.res_scroll();

        } );
    } );
})( jQuery, window, document );
